import { AppCatalogProductService } from "../resource";

const AppCatalogProductModule = {
    namespaced: true,
    state: {
        list: [],
        total: 0,
        loading: false,
        error: null,
        current: null
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        },
        SET_TOTAL(state, total) {
            state.total = total;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_ERROR(state, err) {
            state.error = err;
        },
        SET_CURRENT(state, item) {
            state.current = item;
        }
    },
    actions: {
        async fetchList({ commit }, params) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogProductService.list(params);
                const body = res.data || {};
                commit("SET_LIST", body.data || []);
                commit("SET_TOTAL", body.total || 0);
            } catch (err) {
                commit("SET_LIST", []);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async fetchOne({ commit }, id) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogProductService.get(id);
                commit("SET_CURRENT", (res.data && res.data.data) ? res.data.data : null);
            } catch (err) {
                commit("SET_CURRENT", null);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        create(_, payload) {
            return AppCatalogProductService.create(payload);
        },
        update(_, { id, payload }) {
            return AppCatalogProductService.update(id, payload);
        },
        remove(_, id) {
            return AppCatalogProductService.remove(id);
        },
        // Storefront -> BO product sync (platform MDFStore 9), #339.
        syncToBackoffice() {
            return AppCatalogProductService.syncToBackoffice();
        },
        // ---- seller UI revamp 2026-10-03 ----
        //
        // fetchDetail: the product list's SKU drill-down. Deliberately NOT
        // fetchOne above — that one owns `current` (ONE product, the editor's) and
        // flips the shared `loading` flag, so using it per expanded row would make
        // every row render the last product fetched and spin the whole table while
        // doing it. Returns the detail to the caller, which caches it per row.
        async fetchDetail(_, id) {
            const res = await AppCatalogProductService.get(id);
            return (res && res.data && res.data.data) ? res.data.data : null;
        },
        // PATCH one column (spec §3 BE-1). Errors are NOT swallowed: the list's
        // switch reverts on a rejected promise, so a resolved promise would leave
        // the UI claiming a write that never happened.
        setAppEnable(_, { id, app_enable }) {
            return AppCatalogProductService.setAppEnable(id, app_enable);
        },
        // ---- inline price / quantity edit 2026-10-03 (spec §4) ----
        //
        // PATCH one SKU's price and/or quantity. Errors are NOT swallowed, for a
        // stronger reason than the switch above: this write is money and stock,
        // the UI is deliberately NOT optimistic, and the row is only updated from
        // the resolved response. A swallowed rejection would leave the table
        // showing the operator's draft as if the warehouse had accepted it.
        patchSku(_, { id, sku_id, payload }) {
            return AppCatalogProductService.patchSku(id, sku_id, payload);
        }
    },
    getters: {
        list: state => state.list,
        total: state => state.total,
        loading: state => state.loading,
        error: state => state.error,
        current: state => state.current
    }
};

export default AppCatalogProductModule;
